
import Vue from 'vue';
import '@/assets/css/helpdesk/helpdesk-theme.css';
import Component from 'vue-class-component';
import {namespace} from 'vuex-class';
import PaginationBar from '@/components/shared/PaginationBar.vue';
import {ITicketType} from '@/store/modules/helpdeskTicketTypesModule';

const mod = namespace('helpdeskTicketTypesModule');

@Component({name: 'HelpdeskTicketTypes', components: {PaginationBar}})
export default class HelpdeskTicketTypes extends Vue {
  @mod.Getter('types')       private types!: ITicketType[];
  @mod.Getter('currentPage') private currentPage!: number;
  @mod.Getter('lastPage')    private lastPage!: number;
  @mod.Getter('total')       private total!: number;
  @mod.Getter('perPage')     private perPage!: number;

  private newName         = '';
  private search          = '';
  private searchTimer: any = null;
  private editDialog      = false;
  private editName        = '';
  private editTarget: ITicketType | null = null;
  private confirmDelete   = false;
  private deleteTarget: ITicketType | null = null;
  private selectedPerPage = 15;
  private subscribes: any = {};

  private headers = [
    {text: 'ID',     value: 'id',      width: 60},
    {text: 'Nombre', value: 'name'},
    {text: '',       value: 'actions', sortable: false, width: 104, align: 'end'},
  ];

  created() {
    this.subscribes = (this as any).$ons({
      'backend.call.OK.typeCreated': () => { this.newName = ''; this.loadData(); },
      'backend.call.OK.typeUpdated': () => { this.editDialog = false; },
      'backend.call.OK.typeDeleted': () => { this.loadData(); },
    });
    this.loadData();
  }

  beforeDestroy() { (this as any).$offs(this.subscribes); }

  loadData() {
    const params: any = {page: this.currentPage, per_page: this.selectedPerPage};
    if (this.search) params.search = this.search;
    this.$store.dispatch('helpdeskTicketTypesModule/fetchTypes', params);
  }

  private onPageChange(page: number) {
    const params: any = {page, per_page: this.selectedPerPage};
    if (this.search) params.search = this.search;
    this.$store.dispatch('helpdeskTicketTypesModule/fetchTypes', params);
  }

  private onSearchInput() {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => this.loadData(), 400);
  }

  private onSearchClear() {
    this.search = '';
    this.loadData();
  }

  private onPerPageChange(value: number) {
    this.selectedPerPage = value;
    this.loadData();
  }

  private onCreate() {
    const name = this.newName.trim();
    if (!name) return;
    this.$store.dispatch('helpdeskTicketTypesModule/createType', {name});
  }

  private onEdit(item: ITicketType) {
    this.editTarget = item;
    this.editName   = item.name;
    this.editDialog = true;
  }

  private doEdit() {
    if (!this.editTarget || !this.editName.trim()) return;
    this.$store.dispatch('helpdeskTicketTypesModule/updateType', {
      id: this.editTarget.id, data: {name: this.editName.trim()},
    });
  }

  private onDelete(item: ITicketType) {
    this.deleteTarget = item;
    this.confirmDelete = true;
  }

  private doDelete() {
    if (!this.deleteTarget) return;
    this.confirmDelete = false;
    this.$store.dispatch('helpdeskTicketTypesModule/deleteType', this.deleteTarget.id);
  }
}
